import { Link } from 'react-router-dom';

interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  articleCount: number;
  todayPosts: number;
}

interface CategoryTabsProps {
  categories: Category[];
  activeCategory: string;
}

export default function CategoryTabs({ categories, activeCategory }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className={`flex-shrink-0 flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
            activeCategory === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
          }`}
        >
          <i className={`${cat.icon} ${activeCategory === cat.slug ? '' : 'text-primary-500'}`}></i>
          <span>{cat.name}</span>
          <span className={`text-xs ${activeCategory === cat.slug ? 'text-background-50/70' : 'text-foreground-400'}`}>
            {cat.todayPosts}
          </span>
        </Link>
      ))}
    </div>
  );
}